export default "__VITE_ASSET__c15da6c9__"